import React from 'react';
import { PictoProps } from './index';

export const Place = (props: PictoProps) => (
  <svg
    width={props.width || '10'}
    height={props.height || '14'}
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.1232 13.8949C6.10474 12.8342 9.76744 8.62625 9.76744 4.8893C9.76744 3.59264 9.25293 2.34894 8.33707 1.43208C7.4211 0.515083 6.17891 0 4.88372 0C3.58853 0 2.3462 0.515083 1.43037 1.43208C0.514507 2.34897 0 3.59267 0 4.8893C0 8.62625 3.66256 12.8343 4.64424 13.8949H4.64413C4.70591 13.9619 4.79273 14 4.88377 14C4.97481 14 5.06163 13.9619 5.12341 13.8949H5.1232ZM2.33799 4.8893C2.33799 4.21353 2.60614 3.5653 3.08346 3.08744C3.5609 2.60947 4.20828 2.34103 4.88341 2.34103C5.55855 2.34103 6.20593 2.60947 6.68337 3.08744C7.1607 3.5653 7.42884 4.21353 7.42884 4.8893C7.42884 5.56519 7.16069 6.21341 6.68337 6.69128C6.20593 7.16914 5.55855 7.43769 4.88341 7.43769C4.20828 7.43769 3.5609 7.16914 3.08346 6.69128C2.60613 6.21341 2.33799 5.56519 2.33799 4.8893Z"
      fill="black"
    />
  </svg>
);
